import { FC, lazy, Suspense, useEffect, useRef } from 'react';
import { useQueryLoader } from 'react-relay';
import { Query, initialVars } from './SellerReviewsModalQuery';

import { SellerReviewsModalQuery } from './__generated__/SellerReviewsModalQuery.graphql';

const SellerReviewsModal = lazy(
    () => import(/* webpackChunkName: "SellerReviewsModal" */ './SellerReviewsModal')
);

export const SellerReviewsModalAsync: FC<{
    onClose: () => void;
    isOpen: boolean;
    sellerId: string;
    isMobileScrollContainer?: boolean;
}> = ({ isMobileScrollContainer = false, ...props }) => {
    const [queryReference, loadQuery] = useQueryLoader<SellerReviewsModalQuery>(Query);
    const executed = useRef(false);
    const { isOpen, sellerId } = props;

    useEffect(() => {
        if (isOpen && !executed.current) {
            loadQuery({
                ...initialVars,
                sellerId,
                isMobileScrollContainer,
            });
            executed.current = true;
        } else if (!isOpen && executed.current) {
            //if user closes modal while fetching dispose queryReference
            queryReference?.dispose();
            executed.current = false;
        }
    }, [isOpen, loadQuery, sellerId, isMobileScrollContainer, queryReference]);

    if (!props.isOpen) {
        return null;
    }

    return (
        <Suspense fallback={null}>
            {queryReference ? (
                <SellerReviewsModal
                    {...props}
                    queryReference={queryReference}
                    isMobileScrollContainer={isMobileScrollContainer}
                />
            ) : null}
        </Suspense>
    );
};
